import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subtitle",
  "use": "icon-subtitle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-subtitle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M21,3H3A1,1,0,0,0,2,4V20a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V4A1,1,0,0,0,21,3ZM5.38,6.62h6.93V8.67H9.87v5.38h-2V8.67H5.38ZM18.62,17.38H5.38v-2H18.62Zm0-4.35H12.46V11h6.16Zm0-4.36H14v-2h4.62Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol